import { Controller } from "@hotwired/stimulus"

// Shows / hide `hideableTarget` based on `toggleTarget` checked state
//
// example:
// <div data-controller="display-toggle">
//   <input data-display-toggle-target="toggle" data-action="display-toggle#toggle" type="checkbox">
//   <div data-display-toggle-target="hideable"> CONTENT HIDDEN / SHOWN </div>
// </div>
export default class extends Controller {
  static targets = [
    "toggle",
    "hideable"
  ]

  connect() {
    this.toggle()
  }

  toggle(_) {
    const checked = this.toggleTarget.checked
    this.hideableTargets.forEach(el =>
      el.classList.toggle('d-none', !checked)
    )
  }
}
